module.exports = __webpack_public_path__ + "resources/img/img_cubrid_02_01_m_jp.7acd1cb680c7ed7608c01162cf27cf64.png";